import { IPID } from '../PID';

export interface IControlledPID extends IPID {
    invert: boolean;
    lastExecTime: Date | undefined;
    integral: number;
    lastX: number;
}


export const schema = 'AutomationApps.Functions.Controllers.ControlledPID';



